export default {
  items: [
    {
      icon: "view_list",
      title: "Commissions",
      route: "/list-commissions",
      feature: "default",
      security: "employee"
    },
    {
      icon: "view_list",
      title: "Reports",
      route: "/list-reports",
      feature: "feature1",
      security: "employee",
      subMenu: [
        {
          icon: "view_list",
          title: "Customer Order Report",
          route: "/list-reports/CustomerOrders"
        },
        {
          icon: "view_list",
          title: "Customer Listing",
          route: "/list-reports/CustomerListing"
        },
        {
          icon: "view_list",
          title: "Sales Volume",
          route: "/list-reports/SalesVolume"
        },
        {
          icon: "view_list",
          title: "Sales Volume Summary",
          route: "/list-reports/SalesVolumeSummary"
        }
      ]
    },
    {
      icon: "perm_identity",
      title: "Employees",
      route: "/list-employees",
      feature: "default",
      security: "employee"
    },
    {
      icon: "perm_identity",
      title: "Sub Dealers",
      route: "/list-subdealers",
      feature: "feature1",
      security: "Admin"
    },

    {
      icon: "settings",
      title: "Activity",
      route: "/partner-activity",
      feature: "feature1",
      security: "Admin",
      subMenu: [
        {
          icon: "settings",
          title: "Partner Logins",
          route: "/partner-logins"
        },
        {
          icon: "settings",
          title: "Partner Details",
          route: "/partner-details"
        }
      ]
    },

    {
      icon: "settings",
      title: "Personalise",
      route: "/app-personalise",
      feature: "feature1",
      security: "Admin",
      subMenu: [
        {
          icon: "settings",
          title: "Update My Details",
          route: "/upload-logo"
        },
        {
          icon: "settings",
          title: "Upload Logo",
          route: "/upload-logo"
        },
        {
          icon: "settings",
          title: "Modify Cust Email",
          route: "/modify-custEmail/Email"
        },
        {
          icon: "settings",
          title: "Modify Cust SMS",
          route: "/modify-custEmail/SMS"
        },
        {
          icon: "settings",
          title: "Modify Header",
          route: "/modify-custEmail/OrderReportHeader"
        },
        {
          icon: "settings",
          title: "Modify From Details",
          route: "/modify-custEmail/OrderReportFrom"
        }
      ]
    },
    {
      icon: "settings",
      title: "Reassign Orders",
      route: "/list-reports/CustomerOrders",
      feature: "default",
      security: "Admin"
    },
    {
      icon: "settings",
      title: "Link",
      route: "/link/domains",
      feature: "nampt",
      security: "Vonex"
    }
  ]
};
